"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SafetyOutline = {
    name: 'safety',
    theme: 'outline',
    nameWithTheme: 'safety-o',
    tag: 'svg',
    attrs: { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 1024 1024' },
    children: [
        {
            tag: 'path',
            attrs: {
                d: 'M512 64L128 192v384c0 212.1 171.9 384 384 384s384-171.9 384-384V192L512 64zm312 512c0 172.3-139.7 312-312 312S200 748.3 200 576V246l312-110 312 110v330z'
            },
            children: []
        },
        {
            tag: 'path',
            attrs: {
                d: 'M378.4 475.1c-14.1-14.1-36.9-14.1-50.9 0-14.1 14.1-14.1 36.9 0 50.9l129.4 129.4 2.1 2.1c13.3 13.3 34.8 13.3 48.1 0L730.6 434c13.3-13.3 13.3-34.8 0-48.1l-2.8-2.8c-13.3-13.3-34.8-13.3-48.1 0L483 579.7 378.4 475.1z'
            },
            children: []
        }
    ]
};
exports.default = SafetyOutline;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@1.0.3@@ant-design/icons/lib/outline/SafetyOutline.js
// module id = 806
// module chunks = 0 1